module.exports = __webpack_public_path__ + "img/03-2-2管理工具.043ea971.svg";